import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon } from 'lucide-react';
type Plan = {
  tag: string;
  title: string;
  subtitle?: string;
  features: string[];
  price: string;
  oldPrice: string;
  href: string;
  images: string[];
  highlighted: boolean;
};
const plans: Plan[] = [{
  tag: '8 Habilidades',
  title: '8 Habilidades para Secundaria',
  features: ['116 páginas · 8 habilidades esenciales', 'BONUS 1: Banco de Producciones Escritas', 'BONUS 2: Banco de Debates para Secundaria', 'BONUS 3: 50 Actividades de Ciudadanía', 'BONUS 4: Del Aula al Mundo', 'Acceso inmediato y de por vida'],
  price: '$19.990',
  oldPrice: '$39.990',
  href: 'https://checkout.aula-mater.online/cart/67392862584877:1',
  images: ['https://cdn.magicpatterns.com/uploads/oqQ5tJksQY6ihcLkMfq1Ex/IMAGEN_PRINCIPAL.png'],
  highlighted: false
}, {
  tag: 'Pack Secundaria Completo',
  title: '8 Habilidades + ESI + Efemérides',
  subtitle: 'Con esto completás todo el año escolar',
  features: ['8 Habilidades para Secundaria + los 4 bonus', 'Megapack ESI Secundaria · 25 temas', 'Efemérides Listas Secundaria · todo el año', '3 materiales completos en una sola compra', 'Acceso inmediato y de por vida', 'El mayor ahorro'],
  price: '$29.990',
  oldPrice: '$59.990',
  href: 'https://checkout.aula-mater.online/cart/67392964984877:1',
  images: ['https://cdn.magicpatterns.com/uploads/7jNiKSybu8J8ynExfgdTx6/mockup_esi.png', 'https://cdn.magicpatterns.com/uploads/97svAFdqKnJLbiDqbrxrUu/mockup_efemerides.png'],
  highlighted: true
}];
export function PurchaseSection() {
  return <section id="compra" className="py-10 px-4 bg-black text-white text-center" data-id="element-104" data-mp="1px15xdp75r6r">
      <div className="max-w-5xl mx-auto" data-id="element-105" data-mp="1pzdn3on4rxir">
        <h2 className="text-[20px] md:text-2xl font-black mb-2 text-white" data-id="element-106" data-mp="1uwdv453jjaci">
          Accedé ahora a 8 HABILIDADES PARA SECUNDARIA
        </h2>

        <p className="text-lg md:text-xl font-medium mb-8 max-w-2xl mx-auto text-gray-300" data-id="element-107" data-mp="1zt48gknynru8">
          Elegí la opción que mejor se adapte a vos. Pago único · Acceso de por
          vida.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-3xl mx-auto items-stretch" data-id="element-108" data-mp="1f420be99ytrl">
          {plans.map(plan => <div key={plan.title} className={`relative flex flex-col rounded-3xl p-6 md:p-7 text-left shadow-2xl border-2 ${plan.highlighted ? 'bg-[#17A2AE] border-yellow-400 md:scale-105' : 'bg-gray-900 border-gray-800'}`} data-id="element-109" data-mp="1a58n7mxwh4ry">
              {plan.highlighted && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-yellow-400 text-gray-900 text-xs font-black px-4 py-1 rounded-full shadow-lg whitespace-nowrap" data-id="element-110" data-mp="1xvmh7j01pdp6">
                  ⭐ MÁS ELEGIDO
                </div>}

              <span className={`inline-block self-start text-[10px] md:text-xs font-black px-3 py-1 rounded-full mb-3 uppercase tracking-wide ${plan.highlighted ? 'bg-white/20 text-white' : 'bg-gray-800 text-gray-300'}`} data-id="element-111" data-mp="27u257d3s06ug">
                {plan.tag}
              </span>

              <h3 className="text-2xl md:text-[26px] font-black mb-1 text-white leading-tight" data-id="element-112" data-mp="8ir8qpaoo1vg">
                {plan.title}
              </h3>
              {plan.subtitle && <p className="text-sm font-bold text-yellow-300 mb-3" data-id="element-113" data-mp="2p3wd6tryha2f">
                  {plan.subtitle}
                </p>}

              <ul className="space-y-2 mb-6 mt-2 flex-grow" data-id="element-114" data-mp="2ag1i56qh6tm6">
                {plan.features.map(f => <li key={f} className="flex items-start text-sm md:text-base" data-id="element-115" data-mp="2fdt8hwbh27o9">
                    <CheckIcon className={`w-5 h-5 mr-2 flex-shrink-0 mt-0.5 ${plan.highlighted ? 'text-yellow-300' : 'text-green-500'}`} data-id="element-116" data-mp="21el8x2becxjj" />
                    <span className={plan.highlighted ? 'text-white' : 'text-gray-200'} data-id="element-117" data-mp="25h87dm2kpgpp">
                      {f}
                    </span>
                  </li>)}
              </ul>

              <div className="flex items-end justify-center gap-2 h-40 mb-4" data-id="element-118" data-mp="1wep3qzqyr02e">
                {plan.images.map(src => <img key={src} src={src} alt={plan.title} className="h-full w-auto max-w-none object-contain drop-shadow-xl" data-id="element-119" data-mp="3lu5cie0z6jrr" />)}
              </div>

              <div className="mb-4" data-id="element-120" data-mp="3qrf7e974vnmz">
                <div className="flex items-center gap-2 mb-1" data-id="element-121" data-mp="1qrs3shvcruko">
                  <span className={`text-lg font-bold line-through ${plan.highlighted ? 'text-white/60' : 'text-gray-500'}`} data-id="element-122" data-mp="1qow7exz5ldyc">
                    ARS {plan.oldPrice}
                  </span>
                  <span className="bg-red-600 text-white text-xs font-black px-2.5 py-1 rounded-full" data-id="element-123" data-mp="1hsomnjfqxp8t">
                    50% OFF
                  </span>
                </div>
                <span className={`text-sm font-bold align-top mr-1 ${plan.highlighted ? 'text-white/80' : 'text-gray-400'}`} data-id="element-124" data-mp="17tz21iwgtqov">
                  ARS
                </span>
                <span className="text-4xl md:text-5xl font-black text-white" data-id="element-125" data-mp="y1tceftorlcu">
                  {plan.price}
                </span>
                <p className={`text-xs mt-1 ${plan.highlighted ? 'text-white/80' : 'text-gray-400'}`} data-id="element-126" data-mp="u2kklgi7hxjx">
                  Pago único · Acceso de por vida
                </p>
              </div>

              <CTAButton href={plan.href} className={`w-full text-lg md:text-xl py-4 ${plan.highlighted ? '!bg-white !text-gray-900 !shadow-[0_0_20px_rgba(255,255,255,0.3)] !from-white !to-white' : ''}`} data-id="element-127" data-mp="k44t3cf9om9w">
                👉 LO QUIERO
              </CTAButton>
            </div>)}
        </div>

        <div className="max-w-md mx-auto mt-8" data-id="element-128" data-mp="35po0wln74g8k">
          <CTAButton href="https://wa.me/5491124676057?text=Hola%20te%20hablo%20por%20el%20material%208%20Habilidades%20para%20Secundaria%2C%20quiero%20realizar%20la%20compra%20por%20Whatsapp%20u%20obtener%20mas%20informacion." className="w-full text-lg md:text-xl py-4 mb-4 flex items-center justify-center gap-3 !bg-gradient-to-r !from-[#25D366] !to-[#128C7E] !shadow-[0_0_20px_rgba(37,211,102,0.4)]" data-id="element-129" data-mp="39py5puz950lu">
            <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg" data-id="element-130" data-mp="2qr2d2o31kua4">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-131" data-mp="1u9pjnuhv6nw9" />
            </svg>
            COMPRA POR WHATSAPP
          </CTAButton>

          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1 text-sm font-bold text-gray-300" data-id="element-132" data-mp="aey3p4arqud3">
            <span className="flex items-center" data-id="element-133" data-mp="ff2bm5xm2grp">
              <span className="text-green-500 mr-1" data-id="element-134" data-mp="h1kdp7ogt3w">✔</span> para 12 a 18 años
            </span>
            <span className="flex items-center" data-id="element-135" data-mp="5g4p18jqwxbc">
              <span className="text-green-500 mr-1" data-id="element-136" data-mp="5gw8xm3zd6ls">✔</span> acceso inmediato
            </span>
            <span className="flex items-center" data-id="element-137" data-mp="t6qoibfop99q">
              <span className="text-green-500 mr-1" data-id="element-138" data-mp="t81ri91b2czs">✔</span> descarga digital
            </span>
          </div>
        </div>
      </div>
    </section>;
}